let mapper_options = {
  endpoint: 'local_ad_balances',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      invitation: {
        foreignKey: 'invitation_id',
        localField: 'invitation'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('local_ad_balance', mapper_options)
}
